import { useState, useCallback } from "react";
import { validateTelefono, validateEmail } from "../shared/validations";
import * as clienteService from "../../../services/ClienteService";

const codigosPaises = [
  { label: "Chile (+56)", value: "+56" },
  { label: "Argentina (+54)", value: "+54" },
  { label: "Perú (+51)", value: "+51" },
];

const useContactoForm = (baseUrl, toast) => {
  const [nuevoContactos, setNuevoContactos] = useState([]);
  const [nuevoNombreContacto, setNuevoNombreContacto] = useState("");
  const [nuevoTipoContacto, setNuevoTipoContacto] = useState("");
  const [nuevoTelefonoContacto, setNuevoTelefonoContacto] = useState("");
  const [nuevoCorreoContacto, setNuevoCorreoContacto] = useState("");
  const [codigoPaisContacto, setCodigoPaisContacto] = useState("+56");
  const [indiceEdicionContacto, setIndiceEdicionContacto] = useState(null);
  const [idContacto, setIdContacto] = useState(null);

  const resetFormularioContacto = useCallback(() => {
    setNuevoNombreContacto("");
    setNuevoTipoContacto("");
    setNuevoTelefonoContacto("");
    setNuevoCorreoContacto("");
    setIndiceEdicionContacto(null);
  }, []);

  const handleTelefonoContactoChange = (e) => {
    setNuevoTelefonoContacto(e.target.value.replace(/[^0-9\s()+-]/g, ""));
  };

  const handleCorreoContactoChange = (e) => {
    setNuevoCorreoContacto(e.target.value.replace(/\s/g, ""));
  };

  const checkFormContacto = () => {
    const missingFields = [];
    if (!nuevoNombreContacto) missingFields.push("Nombre");
    if (!nuevoTipoContacto) missingFields.push("Tipo");
    if (!nuevoTelefonoContacto) {
      missingFields.push("Teléfono");
    } else if (!validateTelefono(nuevoTelefonoContacto)) {
      missingFields.push("Teléfono (inválido)");
    }
    if (!nuevoCorreoContacto) {
      missingFields.push("Correo");
    } else if (!validateEmail(nuevoCorreoContacto)) {
      missingFields.push("Correo (inválido)");
    }
    return missingFields;
  };

  const handleGuardarContacto = () => {
    const missingFields = checkFormContacto();
    if (missingFields.length > 0) {
      toast.current?.show({
        severity: "error",
        summary: "Error de Validación",
        detail: "Por favor, complete correctamente los siguientes campos: " + missingFields.join(", "),
        life: 3000,
      });
      return;
    }

    if (
      nuevoContactos.some(
        (contact, index) =>
          index !== indiceEdicionContacto &&
          contact.correo.trim().toUpperCase() === nuevoCorreoContacto.trim().toUpperCase()
      )
    ) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Un contacto con este correo ya existe",
        life: 3000,
      });
      return;
    }

    if (indiceEdicionContacto !== null) {
      const actualizados = [...nuevoContactos];
      actualizados[indiceEdicionContacto] = {
        id: idContacto,
        nombre: nuevoNombreContacto,
        tipo: nuevoTipoContacto,
        telefono: `${codigoPaisContacto} ${nuevoTelefonoContacto}`,
        correo: nuevoCorreoContacto,
      };
      setNuevoContactos(actualizados);
      setIndiceEdicionContacto(null);
      resetFormularioContacto();
    } else {
      const contacto = {
        nombre: nuevoNombreContacto || "SIN NOMBRE",
        tipo: nuevoTipoContacto || "SIN TIPO",
        telefono: `${codigoPaisContacto} ${nuevoTelefonoContacto}` || "SIN TELÉFONO",
        correo: nuevoCorreoContacto || "SIN CORREO",
      };
      setNuevoContactos([...nuevoContactos, contacto]);
      resetFormularioContacto();
    }
  };

  const handleEliminarContacto = (rowIndex) => {
    setNuevoContactos(nuevoContactos.filter((_, index) => index !== rowIndex));
  };

  const handleDesactivarContacto = async (rowIndex) => {
    const contacto = nuevoContactos[rowIndex];
    if (!contacto || !contacto.id) {
      toast.current?.show({
        severity: "warn",
        summary: "ID inválido",
        detail: "No se encontró el ID del contacto a desactivar.",
        life: 3000,
      });
      return;
    }
    try {
      await clienteService.cambiarEstadoContacto(baseUrl, contacto.id, 0);
      setNuevoContactos((prev) => prev.filter((_, idx) => idx !== rowIndex));
      toast.current?.show({
        severity: "success",
        summary: "Contacto Desactivado",
        detail: "El contacto ha sido desactivado con éxito.",
        life: 3000,
      });
    } catch (error) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "No se pudo desactivar el contacto. Debe tener al menos un registro activo.",
        life: 3000,
      });
    }
  };

  const handleSeleccionarContacto = (index) => {
    const con = nuevoContactos[index];
    setIdContacto(con.id);
    setNuevoNombreContacto(con.nombre);
    setNuevoTipoContacto(con.tipo);
    setNuevoTelefonoContacto(con.telefono.replace(/^\+\d+\s*/, ""));
    setNuevoCorreoContacto(con.correo);
    setIndiceEdicionContacto(index);
  };

  const setContactosIniciales = (contactos) => {
    if (contactos) {
      setNuevoContactos(contactos);
    }
  };

  return {
    nuevoContactos,
    setNuevoContactos,
    nuevoNombreContacto,
    setNuevoNombreContacto,
    nuevoTipoContacto,
    setNuevoTipoContacto,
    nuevoTelefonoContacto,
    setNuevoTelefonoContacto,
    nuevoCorreoContacto,
    setNuevoCorreoContacto,
    codigoPaisContacto,
    setCodigoPaisContacto,
    indiceEdicionContacto,
    codigosPaises,
    handleTelefonoContactoChange,
    handleCorreoContactoChange,
    handleGuardarContacto,
    handleEliminarContacto,
    handleDesactivarContacto,
    handleSeleccionarContacto,
    resetFormularioContacto,
    setContactosIniciales,
  };
};

export default useContactoForm;
